// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__EK3dr","spin":"Loader_spin__CFnof"};